import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { Page } from '@app/components/page/Page';
import { ChipNavigationMui } from '@mi-front/ui';
import HistoryIcon from '@mui/icons-material/History';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface AodRunsChipNavigationProps {
  pastRunsContent: ReactNode;
  scheduledRunsContent: ReactNode;
  header?: ReactNode;
  defaultActiveChip?: 'past' | 'scheduled';
  navigationParam?: string;
}

export function AodRunsChipNavigation({
  pastRunsContent,
  scheduledRunsContent,
  header,
  defaultActiveChip = 'past',
  navigationParam,
}: AodRunsChipNavigationProps) {
  const { formatMessage } = useIntl();

  const chips = [
    {
      value: 'past',
      label: formatMessage({
        id: 'audit.aod.rules.view.runs.navigation.activeAndPast',
        defaultMessage: 'Ejecuciones activas/pasadas',
      }),
      icon: <HistoryIcon />,
      content: pastRunsContent,
    },
    {
      value: 'scheduled',
      label: formatMessage({
        id: 'audit.aod.rules.view.runs.navigation.future',
        defaultMessage: 'Ejecuciones programadas',
      }),
      icon: <ScheduleSendIcon />,
      content: scheduledRunsContent,
    },
  ];

  return (
    <ChipNavigationMui
      chips={chips}
      defaultActiveChip={defaultActiveChip}
      header={header}
      param={navigationParam}
      Wrapper={PageToolbar}
      ContentWrapper={Page.Content}
    />
  );
}
